import { render, staticRenderFns } from "./promotionReview.vue?vue&type=template&id=12c72193&scoped=true"
import script from "./promotionReview.vue?vue&type=script&lang=js"
export * from "./promotionReview.vue?vue&type=script&lang=js"
import style0 from "./promotionReview.vue?vue&type=style&index=0&id=12c72193&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c72193",
  null
  
)

export default component.exports